import { render, staticRenderFns } from "./DatePickerVue3.vue?vue&type=template&id=1fd16d45"
import script from "./DatePickerVue3.vue?vue&type=script&lang=js"
export * from "./DatePickerVue3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports